import { Box, Skeleton, SxProps, Theme, TypographyProps } from '@mui/material';
import { APP_CARD_TITLE_HEIGHT } from './AppCardTitle';

interface AppCardTitleSkeletonProps {
  /** Typography scale for em-based height; defaults to subtitle1 to match AppCardTitle. */
  variant?: TypographyProps['variant'];
  /** Width of the title block (CSS width). */
  width?: string | number;
  sx?: SxProps<Theme>;
}

/**
 * Loading placeholder matching AppCardTitle's fixed two-line height.
 * Renders two bars so the skeleton reads as a multi-line title, not one tall block.
 */
export function AppCardTitleSkeleton({
  variant = 'subtitle1',
  width = '80%',
  sx,
}: AppCardTitleSkeletonProps) {
  return (
    <Box
      sx={{
        typography: variant,
        height: APP_CARD_TITLE_HEIGHT,
        width,
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '0.3em',
        ...sx,
      }}
    >
      <Skeleton variant="rounded" width="100%" sx={{ height: '0.85em', transform: 'none' }} />
      <Skeleton variant="rounded" width="65%" sx={{ height: '0.85em', transform: 'none' }} />
    </Box>
  );
}
